/**
 * Team Secrets API Service
 *
 * Provides functions for managing team secrets accessible via notebook capabilities.
 */
import api from './api';

export interface TeamSecret {
  id: string;
  name: string;
  description: string | null;
  key_hint: string;
  created_at: string;
  created_by: string | null;
}

export interface SecretCreate {
  name: string;
  value: string;
  description?: string;
}

/**
 * List all secrets for the current team.
 */
export async function listSecrets(): Promise<TeamSecret[]> {
  const response = await api.get('/settings/secrets');
  return response.data.secrets;
}

/**
 * Create a new secret.
 */
export async function createSecret(data: SecretCreate): Promise<TeamSecret> {
  const response = await api.post('/settings/secrets', data);
  return response.data;
}

/**
 * Delete a secret by name.
 */
export async function deleteSecret(name: string): Promise<void> {
  await api.delete(`/settings/secrets/${encodeURIComponent(name)}`);
}
